export default __webpack_public_path__ + "static/media/testdrive.631b739d.svg";